import { IWorksheetComponent } from 'Components/Worksheets/Core/types';
import { getById } from 'Data/ViewModels/Equipment/ISieveSize';
import { hasNonEmptyValue, hasValue } from 'Lib/Any';
import { combine } from 'Lib/Hooks/Selectors';
import React from 'react';
import { useSelector } from 'react-redux';
import { Field, TextOutput } from '../../../Core';
import { withInjectedProps } from '../../../Core/InjectedPropsContext';

let PortionMaterialSizeDescriptionField: React.FC<IWorksheetComponent> = ({ createWorksheetSelector }) => {
  const upperLimitSieveSizeCaption = useSelector(
    combine(
      [
        createWorksheetSelector!('UpperLimitSieveSizeId'),
        createWorksheetSelector!('data.Equipment.AllSieveSizes', false),
      ],
      (id, sieves) => {
        let sieve = getById(sieves, id);
        if (hasValue(id) && !hasNonEmptyValue(sieve))
          throw new Error(`Could not find sieve size with id ${id} in data.Equipment.AllSieveSizes`);
        return sieve?.Caption;
      }
    )
  );
  const lowerLimitSieveSizeCaption = useSelector(
    combine(
      [
        createWorksheetSelector!('LowerLimitSieveSizeId'),
        createWorksheetSelector!('data.Equipment.AllSieveSizes', false),
      ],
      (id, sieves) => {
        let sieve = getById(sieves, id);
        if (hasValue(id) && !hasNonEmptyValue(sieve))
          throw new Error(`Could not find sieve size with id ${id} in data.Equipment.AllSieveSizes`);
        return sieve?.Caption;
      }
    )
  );

  if (upperLimitSieveSizeCaption && lowerLimitSieveSizeCaption) {
    return (
      <Field
        input={<TextOutput />}
        label="Material Between"
        value={`${upperLimitSieveSizeCaption} and ${lowerLimitSieveSizeCaption}`}
      />
    );
  } else if (upperLimitSieveSizeCaption && !lowerLimitSieveSizeCaption) {
    return <Field input={<TextOutput />} label="Material Smaller Than" value={upperLimitSieveSizeCaption} />;
  } else if (!upperLimitSieveSizeCaption && lowerLimitSieveSizeCaption) {
    return <Field input={<TextOutput />} label="Material Larger Than" value={lowerLimitSieveSizeCaption} />;
  } else {
    return null;
  }
};

PortionMaterialSizeDescriptionField = withInjectedProps(PortionMaterialSizeDescriptionField);

export { PortionMaterialSizeDescriptionField };
